import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit } from 'components';
import { useStoreOnboarding } from '../context';
import { createAdditionalTodos } from './utils';
import { ReactComponent as CircleIcon } from 'assets/ss-icons/circle.svg';
import { ReactComponent as CircleCheckedIcon } from 'assets/ss-icons/circle-checked.svg';

export default function AdditionalTodos({ hideCompleted = false }) {
  const { todos, onMarkTodoDone } = useStoreOnboarding();

  const tasks = useMemo(() => {
    const additionalTodos = createAdditionalTodos(todos, hideCompleted);
    if (!additionalTodos.length) return null;

    return additionalTodos.map(todo => (
      <UiKit.Card.Body key={todo.id} className={styles.todo}>
        <UiKit.Flex gap={16} align="flex-start">
          <UiKit.Flex className={styles.icon} align="center">
            <If test={todo.isDone} otherwise={<CircleIcon />}>
              <CircleCheckedIcon />
            </If>
          </UiKit.Flex>
          <UiKit.Flex direction="column" gap={8} className="flex-1">
            <UiKit.Text weight="bold" className={styles.title}>
              {todo.title}
            </UiKit.Text>
            <UiKit.Text size="sm">{todo.description}</UiKit.Text>
          </UiKit.Flex>
          <Link to={todo.linkTo}>
            <UiKit.Button
              size="sm"
              variant="ghost"
              onClick={() => onMarkTodoDone(todo.id)}
            >
              {todo.linkText}
            </UiKit.Button>
          </Link>
        </UiKit.Flex>
      </UiKit.Card.Body>
    ));
  }, [todos, hideCompleted, onMarkTodoDone]);

  if (!tasks) return null;

  return (
    <UiKit.Flex direction="column" gap={16}>
      <UiKit.Title weight="normal">To-Do Tasks</UiKit.Title>
      <UiKit.Card>{tasks}</UiKit.Card>
    </UiKit.Flex>
  );
}
